'use strict';

angular.module('selfAccessRequestArrivalRoutes', ['selfAccessRequestRoutes'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider

        // Arrival
        .state('selfAccessRequest.arrival', {
            url: '/Arrival',
            abstract: true,
            views: {
                '': {
                    templateUrl: require('./Arrival.tpl.html'),
                    controller: 'ArrivalController'
                },
                'sideBar@selfAccessRequest.arrival': {
                    templateUrl: require('./SideBar.tpl.html'),
                }
            },
        })

        // Location Equipment
        .state('selfAccessRequest.arrival.welcome', {
            url: '/LocationEquipment/Explanation',
            views: {
                'main@selfAccessRequest.arrival': {
                    controller: 'ArrivalLocationEquipmentExplanationController',
                    templateUrl: require('./locationEquipment/arrivalWelcome.tpl.html'),
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["LocationEquipment"][0];
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.locationEquipment', {
            url: '/LocationEquipment',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./locationEquipment/LocationEquipment.tpl.html'),
                    controller: 'ArrivalLocationEquipmentController',
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["LocationEquipment"][0];
                        }]
                    }
                }
            }
        })

        // Pre Authorized
        .state('selfAccessRequest.arrival.preAuthorizedHelp1', {
            url: '/PreAuthorized/Explanation',
            views: {
                'main@selfAccessRequest.arrival': {
                    controller: 'ArrivalPreAuthorizedExplanationController',
                    templateUrl: require('./preAuthorized/PreAuthorizedExplanation1.tpl.html'),
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorized"][0];
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.preAuthorizedHelp2', {
            url: '/PreAuthorized/Explanation2',
            views: {
                'main@selfAccessRequest.arrival': {
                    controller: 'ArrivalPreAuthorizedExplanationController',
                    templateUrl: require('./preAuthorized/PreAuthorizedExplanation2.tpl.html'),
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorized"][0];
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.preAuthorized', {
            url: '/PreAuthorized/{employeeID}/SystemType',
            views: {
                'main@selfAccessRequest.arrival': {
                    controller: 'ArrivalPreAuthorizedSystemTypeListController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorized');
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.preAuthorizedBySystemType', {
            url: '/PreAuthorized/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./preAuthorized/PreAuthorized.tpl.html'),
                    controller: 'ArrivalPreAuthorizedBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorized');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorized"][0];
                        }]
                    }
                }
            }
        })

        // Additional Steps
        .state('selfAccessRequest.arrival.additionalSteps', {
            url: '/AdditionalSteps',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./ArrivalAdditionalSteps.html'),
                }
            }
        })

        // Same As
        .state('selfAccessRequest.arrival.sameAs', {
            url: '/SameAs/{sameAsEmployeeID}/SystemType',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./sameAs/SameAs.tpl.html'),
                    controller: 'ArrivalSameAsSystemTypeListController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'sameAs');
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.sameAsBySystemType', {
            url: '/SameAs/{sameAsEmployeeID}/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./sameAs/SameAs.tpl.html'),
                    controller: 'ArrivalSameAsBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'sameAs');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["SameAs"][0];
                        }]
                    }
                },
                'sideBar@selfAccessRequest.arrival': {
                    templateUrl: require('./SideBarForSameAs.tpl.html'),
                    controller: 'ArrivalSideBarSameAsController'
                }
            }
        })

        //Pre Authorized Delta
        .state('selfAccessRequest.arrival.preAuthorizedDelta', {
            url: '/PreAuthorizedDelta/{employeeID}/SystemType',
            views: {
                'main@selfAccessRequest.arrival': {
                    controller: 'ArrivalPreAuthorizedDeltaSystemTypeListController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorized');
                        }]
                    }
                }
            }
        })

        .state('selfAccessRequest.arrival.preAuthorizedDeltaBySystemType', {
            url: '/PreAuthorizedDelta/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./preAuthorizedDelta/PreAuthorizedDelta.tpl.html'),
                    controller: 'ArrivalPreAuthorizedDeltaBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorizedDelta');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorizedDelta"][0];
                        }]
                    }
                }
            }
        })

        // Other Catalog
        .state('selfAccessRequest.arrival.otherCatalog', {
            url: '/OtherCatalog',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./otherCatalog/OtherCatalog.tpl.html'),
                    controller: 'ArrivalOtherCatalogController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'OtherCatalogPermissions');
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["OtherCatalogPermissions"][0];
                        }]
                    }
                }
            }
})

        // Other Needs
        .state('selfAccessRequest.arrival.otherNeeds', {
            url: '/OtherNeeds',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./specialNeeds/OtherNeeds.tpl.html'),
                    controller: 'ArrivalOtherNeedsController',
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["SpecialNeeds"][0];
                        }]
                    }
                }
            }
        })

         // Validation
        .state('selfAccessRequest.arrival.validation', {
             url: '/Validation',
             views: {
                 'main@selfAccessRequest.arrival': {
                     templateUrl: require('./submit/ArrivalSubmit.html'),
                     controller: 'ArrivalSubmitController',
                     resolve: {
                         decisionListWithImpact: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                             return service.getUserSystemRoleDecisionsToValidate($stateParams.userAccessRequestId);
                         }],
                         processStep: ['processStepsByStepName', function (processStepsByStepName) {
                             return processStepsByStepName["Submit"][0];
                         }]
                     }
                 }
             }
        })

         // Completed
        .state('selfAccessRequest.arrival.completed', {
            url: '/Completed',
            views: {
                'main@selfAccessRequest.arrival': {
                    templateUrl: require('./ArrivalCompleted.tpl.html'),
                    controller: 'ArrivalCompletedController',
                    resolve: {
                        requestWithSNOWParams: ['$stateParams', 'selfAccessRequestService', function ($stateParams, service) {
                            return service.getSelfAccessRequestWithSNOWParams($stateParams.userAccessRequestId);
                        }]
                    }
                }
            }
        })

}]);
